import React, { Component } from 'react';
import './BenefitsTabs.css';
import OnDataDeleteModal from '../OnDataDeleteModal/OnDataDeleteModal'

class BenefitsTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deleteModal: false
        }
    }
    componentWillMount() {
        if (this.props.benefits.benefitsLadderData.Items.length > 0) {
            this.props.onChangeSelectedBenefit()
            this.setState({
                data: this.props.benefits.benefitsLadderData.Items[0].data
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.benefits.benefitsLadderFetched && nextProps.benefits.benefitsLadderData.Items.length > 0) {
            this.setState({
                data: nextProps.benefits.benefitsLadderData.Items[0].data
            })
        }
    }
    // Values functions
    onChangeValue = (value) => {
        let newValue = {
            important: false,
            name: value
        }
        this.setState({
            newValue: newValue
        })
    }
    onNewValueAdd = (key) => {
        if (this.state.newValue) {
            let input = document.getElementsByClassName("valuesinput");
            for (let i in input) {
                if (input[i].value) {
                    input[i].value = ""
                }
            }
            let data = this.state.data
            data[key].values.push(this.state.newValue)
            this.setState({
                data: data,
                newValue: null
            }, () => this.props.getBenfitsData(this.state.data))
        }
    }
    onValueCheckBoxSelect = (e, key, index) => {
        let data = this.state.data;
        data[key].values[index].important = e.target.checked;
        this.setState({
            data: data
        }, () => this.props.getBenfitsData(this.state.data))
    }
    onValueDelete = (key, index) => {
        let data = this.state.data;
        let values = [];
        data[key].values.map((item, i) => {
            if (i !== index) {
                values.push(item)
            }
        })
        data[key].values = values;
        this.onDeleteModalClose()
        this.setState({
            data: data
        // }, () => this.props.getBenfitsData(this.state.data))
      }, () => this.props.saveNewData(this.state.data))
    }

    //Benefits functions
    onChangeBenefits = (value) => {
        const uuidv1 = require('uuid/v1');
        uuidv1();
        let newBenefits = {
            important: false,
            name: value,
            id: uuidv1()
        }
        this.setState({
            newBenefits: newBenefits
        })
    }
    onNewBenefitsAdd = (key) => {
        if (this.state.newBenefits) {
            let input = document.getElementsByClassName("benefitsinput");
            for (let i in input) {
                if (input[i].value) {
                    input[i].value = ""
                }
            }

            let data = this.state.data
            data[key].benefits.push(this.state.newBenefits)
            this.setState({
                data: data,
                newBenefits: null
            }, () => this.props.getBenfitsData(this.state.data))
        }
    }
    onBenefitsCheckBoxSelect = (e, key, index) => {
        let data = this.state.data;
        data[key].benefits[index].important = e.target.checked;
        this.setState({
            data: data
        }, () => this.props.getBenfitsData(this.state.data))
    }
    onBenefitsDelete = (key, index) => {
        let data = this.state.data;
        let benefits = [];
        data[key].benefits.map((item, i) => {
            if (i !== index) {
                benefits.push(item)
            }
        })
        data[key].benefits = benefits;
        this.onDeleteModalClose()
        this.setState({
            data: data
        // }, () => this.props.getBenfitsData(this.state.data))
        }, () => this.props.saveNewData(this.state.data))
    }

    //Attributes functions
    onChangeAttributes = (value) => {
        let newAttributes = {
            important: false,
            name: value
        }
        this.setState({
            newAttributes: newAttributes
        })
    }
    onNewAttributesAdd = (key) => {
        if (this.state.newAttributes) {
            let input = document.getElementsByClassName("attributesinput");
            for (let i in input) {
                if (input[i].value) {
                    input[i].value = ""
                }
            }
            let data = this.state.data
            data[key].attributes.push(this.state.newAttributes)
            this.setState({
                data: data,
                newAttributes: null
            }, () => this.props.getBenfitsData(this.state.data))
        }
    }
    // onAttributesCheckBoxSelect = (e, key, index) => {
    //     let data = this.state.data;
    //     data[key].attributes[index].important = e.target.checked;
    //     this.setState({
    //         data: data
    //     }, () => this.props.getBenfitsData(this.state.data))
    // }
    onAttributesDelete = (key, index) => {
        let data = this.state.data;
        let attributes = [];
        data[key].attributes.map((item, i) => {
            if (i !== index) {
                attributes.push(item)
            }
        })
        data[key].attributes = attributes
        this.onDeleteModalClose()
        this.setState({
            data: data
        // }, () => this.props.getBenfitsData(this.state.data))
        }, () => this.props.saveNewData(this.state.data))
    }

    addTabs = (data) => {
        let tabs = []
        if (data.length > 0) {
            let tab1 = document.getElementsByClassName('nav-link')[0]
            if (data.length === 1 && tab1) {
                tab1.click();
            }
            data.map((item, key) => {
                tabs.push(<li className="nav-item" key={item.groupName} onClick={()=>this.props.onTabChange(key)}>
                    <a data-toggle="tab" className={key === this.props.tabStep ? "nav-link active show" : "nav-link"} href={`#${item.groupName}`} aria-controls={`${item.groupName}`} aria-selected="true">{item.groupName} <i className="fa fa-minus minus-icon" onClick={() => this.props.onDeleteModalOpen({ groupName: item.groupName })}></i></a>
                </li>)
            })
        }
        return tabs
    }
    onDeletModalOpen = (name, key, index) => {
        this.setState({
            name: name,
            key: key,
            index: index,
            deleteModal: true
        })
    }
    onDeleteModalClose = () => {
        this.setState({
            name: '',
            key: '',
            index: '',
            deleteModal: false
        })
    }
    addTabContents = (data) => {
        let content = [];
        if (data.length > 0) {
            data.map((item, key) => {
                content.push(
                    <div id={item.groupName} className={key === this.props.tabStep ? "tab-pane fade show active tabContentdiv" : "tab-pane fade tabContentdiv"} role="tabpanel" key={key}>
                        {/* <div className="container"> */}
                        <div className="row">
                            <div className="col-md-4">
                                <div className="alignCenter">
                                    <label>Values</label>
                                    <input type="text" className="tabContentInput valuesinput" onChange={(e) => this.onChangeValue(e.target.value)} onKeyPress={(e) => { e.key == 'Enter' && this.onNewValueAdd(key) }} />
                                    <i className="fa fa-plus plusbtn plus-icon" onClick={() => this.onNewValueAdd(key)}></i>
                                </div>
                                {this.state.data && this.state.data[key].values.length > 0 && this.state.data[key].values.map((item, index) => {
                                    return <div className="addedValues" key={index}>
                                        <label>{item.name}</label>
                                        <div>
                                            <input type="checkbox" checked={item.important} onChange={(e) => this.onValueCheckBoxSelect(e, key, index)} />
                                            <i className="fa fa-minus minus-icon" onClick={() => this.onDeletModalOpen("Value",key, index)}></i>
                                        </div>
                                    </div>
                                })}
                            </div>
                            <div className="col-md-4">
                                <div className="alignCenter">
                                    <label>Benefits</label>
                                    <input type="text" className="tabContentInput benefitsinput" onChange={(e) => this.onChangeBenefits(e.target.value)} onKeyPress={(e) => { e.key == 'Enter' && this.onNewBenefitsAdd(key) }} />
                                    <i className="fa fa-plus plusbtn plus-icon" onClick={() => this.onNewBenefitsAdd(key)}></i>
                                </div>
                                {this.state.data && this.state.data[key].benefits.length > 0 && this.state.data[key].benefits.map((item, index) => {
                                    return <div className="addedValues" key={index}>
                                        <label>{item.name}</label>
                                        <div>
                                            <input type="checkbox" checked={item.important} onChange={(e) => this.onBenefitsCheckBoxSelect(e, key, index)} />
                                            <i className="fa fa-minus minus-icon" onClick={() => this.onDeletModalOpen("Benefit",key, index)}></i>
                                        </div>
                                    </div>
                                })}
                            </div>
                            <div className="col-md-4">
                                <div className="alignCenter">
                                    <label>Attributes</label>
                                    <input type="text" className="tabContentInput attributesinput" onChange={(e) => this.onChangeAttributes(e.target.value)} onKeyPress={(e) => { e.key == 'Enter' && this.onNewAttributesAdd(key) }} />
                                    <i className="fa fa-plus plusbtn plus-icon" onClick={() => this.onNewAttributesAdd(key)}></i>
                                </div>
                                {this.state.data && this.state.data[key].attributes.length > 0 && this.state.data[key].attributes.map((item, index) => {
                                    return <div className="addedValues" key={index}>
                                        <label>{item.name}</label>
                                        <div>
                                            {/* <input type="checkbox" checked={item.important} onChange={(e) => this.onAttributesCheckBoxSelect(e, key, index)} /> */}
                                            <i className="fa fa-minus minus-icon" onClick={() => this.onDeletModalOpen("Attribute",key, index)}></i>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                        {/* </div> */}
                    </div>
                )
            })
        }
        return content
    }
    render() {
        return (
            <React.Fragment>
                {this.state.deleteModal &&
                    <OnDataDeleteModal
                        onDeleteModalClose={this.onDeleteModalClose}
                        name={this.state.name}
                        keys={this.state.key}
                        index={this.state.index}
                        onAttributesDelete={this.onAttributesDelete}
                        onBenefitsDelete={this.onBenefitsDelete}
                        onValueDelete={this.onValueDelete}
                    />
                }
                <div className="col-xl-10 col-lg-12 col-md-12">
                    <ul className="nav nav-tabs benefitsNavTabs" role="tablist" id="myTab">
                        <li className="nav-item">
                            <a id='plusTab' onClick={() => this.props.onPlusBtn()}><i className="fa fa-plus plusbtn plus-icon"></i></a>
                        </li>
                        {this.props.benefits.benefitsLadderFetched && this.props.benefits.benefitsLadderData.Items.length > 0 && this.addTabs(this.props.benefits.benefitsLadderData.Items[0].data)}
                    </ul>

                    <div className="tab-content benefitsTabcontent" id="myTabContent" >
                        {this.props.benefits.benefitsLadderFetched && this.props.benefits.benefitsLadderData.Items.length > 0 && this.addTabContents(this.props.benefits.benefitsLadderData.Items[0].data)}
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default (BenefitsTabs);



// WEBPACK FOOTER //
// ./src/components/BenefitsLadder/BenefitsTabs/BenefitsTabs.jsx